<template>
<div class="container-fluid">
	<div class="row mb-3">
		<div class="col-6">
			Set Date Range
			<date-picker 
				v-model="start_date"
				:config="config.datePickerOptions"
				class="date-picker form-control-sm"
				data-test="reportStartDate" />

			<date-picker
				v-model="end_date"
				:config="config.datePickerOptions"
				class="date-picker form-control-sm"
				data-test="reportEndDate" />

			<button class="btn btn-primary" @click="getCheckinsNew()">Go</button>
		</div>

		<div class="col-6">
			<div v-for="user in userList">
				<input type="checkbox" :value="user" v-model="selectedUsers"> {{ user }}
			</div>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-6">
			<div class="card">
				<highcharts :options="checkinDatesByUser"></highcharts>
			</div>
		</div>
		<div class="col-6">
			<div class="card">
				<highcharts :options="checkinTypesByUser"></highcharts>
			</div>
		</div>
	</div>
	<div class="row mb-3">
		<div class="col-12">
			<div class="card text-center">
				Checkin Locations
				<GmapMap
					ref="checkinMap"
					:center=default_center
					:zoom="5"
					map-type-id="roadmap"
					style="height:350px; margin:0 0px 0px 0px;"
				/>

			</div>
		</div>
	</div>
</div>
</template>

<script>
// import { Chart } from 'highcharts-vue';
// import Maps from "highcharts/modules/map";

// import mapInit from "highcharts/modules/map";
// import mapData from "@highcharts/map-collection/custom/world.geo.json";
import mapData from "@highcharts/map-collection/countries/us/us-all.geo.json";


import { mapState } from 'vuex';

export default {
	components: {
    	//highcharts: Chart 
	},

	data() {
		return {
			start_date: moment().subtract(3, 'months'),
			end_date: moment(),
			loaded: false,

			default_center: {},

			allCheckins: [],
			userList: [],
			selectedUsers: [],

			checkinLocations: [],
			markers: [],

			icon: { //base icon styling
				path: 'M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z',
				fillColor: '#EE2742',
				fillOpacity: 1,
				strokeWeight: 1.25,
				strokeColor: 'rgba(255,255,255,.8)',				    
				size: {width: 24, height: 24, f: 'px', b: 'px'},
				anchor: {x: 12, y: 24, },
				scale: 1.5
			},       		     		
      	}
    },

    created() {
		this.getCheckinsNew();
		this.default_center = { 
			lat: 34,
			lng: -118
		};
    },

    methods: {
    	getCheckinsNew() {
    		axios.post('/api/reports/newtest', { start_date: moment(this.start_date).format('YYYY-MM-DD'), end_date: moment(this.end_date).format('YYYY-MM-DD') }).then(({data}) => {
				this.allCheckins = data;
				this.userList = [...new Set(data.map(item => item.user_name))];
				this.selectedUsers = this.userList;
    		});
    	},

		makeMap() {
			console.log('map');
			Vue.nextTick( () => {
				this.$refs.checkinMap.$mapPromise.then((map) => {
					console.log(this.checkinLocationsByUser);
					if (Object.keys(this.checkinLocationsByUser).length > 0) {
						let bounds = new google.maps.LatLngBounds();
						console.log('if')
						//add markers to the map
						Object.keys(this.checkinLocationsByUser).forEach(key => {
							console.log(key);

							this.checkinLocationsByUser[key].forEach(checkin => {							
								if (checkin.latitude !== null && checkin.longitude !== null) {
									let marker = new google.maps.Marker({
										position: new google.maps.LatLng(checkin.latitude, checkin.longitude),
										icon: this.icon,
										map: map,
									});

									bounds.extend(marker.position);
									this.markers.push(marker);
								}							
							});
						});

						map.fitBounds(bounds);
					}
				});
			});
		},

    },

    computed: {
    	...mapState(['config', 'options']),

		checkins() {
			return this.allCheckins.filter(checkin => this.selectedUsers.includes(checkin.user_name));
		},

		checkinDatesByUser() {
			let userCheckins = _.groupBy(this.checkins, 'user_name');
			let checkinSeries = [];
			
			Object.keys(userCheckins).forEach(userName => {
				let dateCounts = _.countBy(userCheckins[userName], 'created_at');
				let counts = [
					[moment(this.start_date).unix()*1000, 0], //sets the min/max on chart X axis
					[moment(this.end_date).unix()*1000, 0],
				];

				Object.keys(dateCounts).forEach(date => {
					counts.push([moment(date).unix()*1000, dateCounts[date]])
				});

				checkinSeries.push({
					name: userName,
					data: counts
				});				
			});

			return {
				chart: {
					type: 'column',
					zoomType: 'x',
				},
				title: {
					text: 'Checkins over time (by User)',
				},	
    plotOptions: {
      column: {
        stacking: 'normal',
        // dataLabels: {
        //   enabled: true,
        //   color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
        // }
      }
    },				
				xAxis: {
					type: 'datetime',
					// dateTimeLabelFormats: { // don't display the dummy year
					//   month: '%b %e',
					//   year: '%b'
					// },
					title: {
						text: 'Date'
					}
				},

				series: checkinSeries
			}		
		},

		checkinLocationsByUser() {
			return _.groupBy(_.uniqBy(this.checkins.filter(checkin => checkin.latitude && checkin.longitude), checkin => [checkin.user_id, checkin.latitude, checkin.longitude].join()), 'user_name')
			;
		},

		checkinTypesByUser() {
			let checkinTypes = this.options.checkin_types.map(item => item.label);
			let userCheckins = _.groupBy(this.checkins, 'user_name');
			let checkinSeries = [];

			Object.keys(userCheckins).forEach(userName => {
				let counts = [];
				//loop each checkin type and count the matches
				checkinTypes.forEach(type => {
					counts.push(userCheckins[userName].filter(checkin => checkin.checkin_type == type).length);
				});

				checkinSeries.push({
					name: userName,
					data: counts
				});
			});

			return {
				chart: {
					type: 'column',
	                type: 'bar',
	            },
                title: {
                	text: 'Checkin types by User',
                },
    plotOptions: {
      series: {
        stacking: 'normal',
        // dataLabels: {
        //   enabled: true,
        //   color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
        // }
      }
    },
				xAxis: {
			        categories: checkinTypes,
			        title: {
			            text: null
			        }
				},
			    yAxis: {
			        min: 0,
			        title: {
			            text: 'Checkin Count',
			            align: 'high'
			        },
			        labels: {
			            overflow: 'justify'
			        }
			    },
        		series: checkinSeries
      		}
		},
    },

	watch: {
		checkinLocationsByUser() {
			this.makeMap();
		}
	}
}

</script>



